const dataDefault = {
  settings: {
    pageLiked: false,
    imagesPerPage: 50,
    imagesSize: [
      'small',
      'medium',
      'large'
    ],
    imagesSizeCurrent: 1,
    theme: 'fantasy'
  },
  liked: [
    
  ],
  temp: [
    
  ]
};

export default dataDefault;